export const DEFAULT_SELECTED_COMP_LIMIT = 10;
export const NUM_HC_SUGGESTED_COMPS = 6;
